


















import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableOptions,
    getTableCaption,
    columnTemplates,
} from '@/core/components/table';
import { Page } from '@/core/components/controls';
import { FetchServiceContract, CONTRACTS } from '@/core/contracts';
import { StructuredResult, LogMessages } from '@/dto';
import LogTable from './LogTable.vue';

@Component({
    components: {
        LogTable,
        TableOptions,
    },
})
export default class LogPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'log-control';

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public async mounted() {
        this.table = this.getTable().getDataGridInstance();
    }

    public setTable(table: Table): void {
        this.table = table;
    }

    public getTable(): LogTable {
        const element = this.$refs['table-control'] as unknown;
        return element as LogTable;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            load: this.load,
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    private async load() {
        const url = `/log`;
        const data = await this._fetchService!.get<
            StructuredResult<LogMessages>
        >(url);
        return { data };
    }
}
